export default "__VITE_ASSET__efgjoZr9__"